import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { RadioButtons } from "../../../FlowConfigurationInputs";
import { Button } from "@material-ui/core";
import CaptureArea from "../../Ocr/CaptureTextFromImage/CaptureArea";
import { activeAutom, openDesktopRecordAtom } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useSetRecoilState } from 'recoil';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Hover({
    action,
    variables,
    setOpenVariable,
    variableRender,
    actions,
    fromFlow,
    handleSave
}) {
    const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
    const [openCaptureArea, setOpenCaptureArea] = useState(false);
    const [fileName, setFileName] = useState("");
    const [upImg, setUpImg] = useState();
    const [value, setValue] = useState(0);
    const [cropImg, setCropImg] = useState("");
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const setOpenDesktopRecord = useSetRecoilState(openDesktopRecordAtom);

    let clickDiv = null;
    const reader = new FileReader();

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.FIND-AND-CLICK.";

    const mouseTypeOptions = {
        radioButtons: {
            data: [
                {
                    value: "right",
                    label: label + "RIGHT",
                },
                {
                    value: "left",
                    label: label + "LEFT",
                },
            ],
            defaultValue: "left",
        }
    };

    const clickTypeOptions = {
        radioButtons: {
            data: [
                {
                    value: "single",
                    label: label + "SINGLE",
                },
                {
                    value: "double",
                    label: label + "DOUBLE",
                },
            ],
            defaultValue: "single",
        }
    };


    function findScopeAction(nodes, mainNodes) {
        for (let node of nodes) {
            if ('children' in node) {
                findScopeAction(node.children, node);
            } else if (node.id === action.id) {
                if (mainNodes?.fields?.getSS || actions[mainNodes?.id]?.fields?.getSS) {
                    let getSSURL = actions[mainNodes?.id]?.fields?.getSS?.value?.length ? actions[mainNodes.id].fields.getSS.value : mainNodes.fields.getSS?.value
                    setUpImg(getSSURL);
                    if (
                        (action.fields.destination.value.x === 0 &&
                            action.fields.destination.value.y === 0)
                    ) {
                        action.fields.destination = { value: { x: 0, y: 0 } };
                        action.fields.source = { value: { x: 0, y: 0 } };
                        setImgCoordinate({ coordinates: [] });
                    }
                }
            }
        }
    }

    useEffect(() => {
        if (!action.fields.imgURL) {
            action.fields.imgURL = { value: "" };
        } else {
            setUpImg(action.fields.imgURL.value);
        }
        if (!action.fields.completedCrop) {
            action.fields.completedCrop = { value: [] };
        } else {
            setImgCoordinate({ coordinates: action.fields.completedCrop.value });
        }
        if (!action.fields.fileName) {
            action.fields.fileName = { value: "" };
        } else {
            setFileName(action.fields.fileName.value);
        }
        if (!action.fields.fileSize) {
            action.fields.fileSize = { value: 0 };
        }
        if (!action.fields.mediaSize) {
            action.fields.mediaSize = { value: { width: 0, height: 0, div: 0 } };
        }
        if (!action.fields.gridCrop) {
            action.fields.gridCrop = { value: [] };
        }

        if (!action.fields.resolution) {
            action.fields.resolution = { value: { width: 0, height: 0 } };
        }

        if (!action.fields.highlightedElements) {
            action.fields.highlightedElements = { value: { clickedObj: [], neighbourObj: [] } }
        }

        if (!action.fields.destination) {
            action.fields.destination = { value: { x: 0, y: 0 } };
        }
        if (!action.fields.source) {
            action.fields.source = { value: { width: 0, height: 0, x: 0, y: 0, id: "asdf" } };
        }
        if (!action.fields.difference) {
            action.fields.difference = { value: "" };
        }
        if (!action.fields.cropImg) {
            action.fields.cropImg = { value: "" };
        } else {
            setCropImg(action.fields.cropImg.value);
        }
        let items = JSON.parse(JSON.stringify(automDetail.items))
        findScopeAction(items);
    }, [action, variables, variableRender]);

    return (
        <>
            <div className="conf-field-container" style={{ marginBottom: !fromFlow && "0" }}>
                {fromFlow && <div>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenDesktopRecord(true)}
                        style={{
                            background: "#031226",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                            borderRadius: 4,
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: '11px'
                        }}
                    >
                        {t(label + "INITIATE-SELECTOR")}
                    </Button>
                </div>}
            </div>
            <div className="conf-field-container" style={{display: "none"}}>
                <FieldLabel name={t(label + 'TYPE')} />
                <RadioButtons
                    action={action}
                    inputName="mouseType"
                    options={mouseTypeOptions.radioButtons}
                    isRequired
                />
            </div>
            <div className="conf-field-container" style={{display: "none"}}>
                <FieldLabel name={t(label + 'CLICK-TYPE')} />
                <RadioButtons
                    action={action}
                    inputName="clickType"
                    options={clickTypeOptions.radioButtons}
                    isRequired
                />
            </div>
            {
                !fromFlow && handleSave && (
                    <Button
                        variant="outlined"
                        className="desktop-actions-hover-button"
                        onClick={() => handleSave()}
                    >
                        {t(label + "CREATE-SELECTOR")}
                    </Button>
                )
            }
        </>
    );
}

export default Hover;
